import styled from "@emotion/styled";

export const NotificationWrapper = styled("div")(() => ({
  display: "flex",
  width: "100%",
  alignItems: "center",
  flexDirection: "column" as const,
  padding: "0 32px 24px",
}));

export const EmptyNotificationImg = styled("img")(() => ({
  width: 150,
}));

export const EmptyNotificationBody = styled("div")(() => ({
  marginTop: 24,
  width: 340,
  display: "flex",
  flexDirection: "column" as const,
  gap: 8,
  textAlign: "center" as const,
}));

export const Title = styled("span")(() => ({
  color: "#344054",
  font: "700 18px/28px Manrope",
}));

export const Text = styled("span")(() => ({
  color: "#667085",
  font: "400 14px/21px Manrope",
}));
